export const ADMIN_URL_PREFIX = 'admin.';
export const LOGIN_URL_PREFIX = 'login.';

export const ROUTE_ONE_DOMAIN = 'routeone';
export const DEALER_TRACK_DOMAIN = 'dealertrack';
